import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";
import { DEMO_DISCLAIMER } from "@/lib/format";

export default function DemoBanner() {
  const items = Array.from({ length: 8 });
  return (
    <div className="bg-forest py-2" data-testid="demo-banner">
      <Marquee speed={35} gradient={false} direction="right" pauseOnHover>
        {items.map((_, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-3 text-gold text-sm font-heading font-medium">
            <Sparkle className="h-3.5 w-3.5" aria-hidden="true" />
            {DEMO_DISCLAIMER}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
